import React from 'react';
import { isMobileWithOutIpad } from '@helpers/EnvHelper';
import { useTranslation } from 'react-i18next';

/**
 *
 * @property {JSX.Element} title
 * @property {JSX.Element} content
 */
const ShareBtn = ({ src, type, title }) => {
  const { t, i18n } = useTranslation();
  let download_src = src;
  let targetAttr = '_blank';
  if (src) {
    const hostName = window.location.protocol + '//' + window.location.host;
    let replaced_str = src.replace(hostName, '');
    download_src = replaced_str;

    const isBrowser = typeof window !== 'undefined';
    const downloadAttributeSupport =
      isBrowser && 'download' in document.createElement('a');

    if (downloadAttributeSupport) {
      targetAttr = '_self';
    }
  }

  async function copyToClip() {
    if (isMobileWithOutIpad()) {
      try {
        navigator
          .share({
            title: title,
            text: '',
            url: window.location,
          })
          .then(() => console.log('공유 성공'))
          .catch(error => console.log('공유 실패', error));
      } catch (e) {
        await navigator.clipboard.writeText(window.location);
        alert(`${t('복사되었습니다.')}`);
      }
    } else {
      await navigator.clipboard.writeText(window.location);
      alert(`${t('복사되었습니다.')}`);
    }
  }

  const downloadStyle = {
    backgroundImage: 'url(/img/media/down.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: '24px',
  };

  return (
    <div className="mt-10  ">
      <a
        onClick={() => copyToClip()}
        className="cursor-pointer pt-4 items-center inline-block mr-4 text-center rounded-full bg-[#e6e6e6] w-[55px] h-[55px] inline-block"
      >
        <img src="/img/media/link.svg" alt="" className="w-[24px] m-auto " />
      </a>
      {type == 'image' && (
        <a
          download
          target={targetAttr}
          href={download_src}
          className="cursor-pointer  pt-4 items-center inline-block mr-4 rounded-full bg-[#e6e6e6] w-[55px] h-[55px] inline-block"
          style={downloadStyle}
        ></a>
      )}
    </div>
  );
};

export default ShareBtn;
